import { query } from '@confluence/query-preloader-tools';
import {
	type SpaceOverviewIdQueryType,
	type SpaceOverviewIdQueryVariables,
} from '@confluence/content-types-utils/entry-points/SpaceOverviewIdQuery';
import { SpaceOverviewIdQuery } from '@confluence/content-types-utils/entry-points/SpaceOverviewIdQuery.graphql';

export function preloadSpaceOverviewId(spaceKey: string): Promise<{
	result: { data: SpaceOverviewIdQueryType | null };
	hasErrors: boolean;
}> {
	return query<SpaceOverviewIdQueryType, SpaceOverviewIdQueryVariables>({
		query: SpaceOverviewIdQuery,
		variables: {
			spaceKey,
		},
	}).then((result) => ({ result, hasErrors: result.hasErrors }));
}
